import React from "react";

const Footer = () => {
    return (
        <div className="w-100 xl:px-20 lg:px-12 sm:px-6 px-4 py-12 bg-neutral-900 border-t-4 border-t-orange-600 mt-20">
            <div className="flex flex-col items-center justify-center">
                    <div className="flex flex-row items-center justify-center ml-5">
                    <img
                        className="h-12 w-auto sm:h-16"
                        src="./assets/images/devlogo.png"
                        alt="WebDeveloper Simon Lohmann"
                      />
                      <div className="flex flex-col justify-start items-start pl-4">
                        <span className="font-semibold text-orange-600">Frontend Developer</span>
                        <span className="text-indigo-100 font-extrabold">Simon Lohmann</span>
                      </div>
                    </div>
                <div className="flex flex-wrap sm:gap-10 gap-8 items-center justify-center mt-8">
                    <p className="hover:text-gray-500 text-base cursor-pointer leading-4 text-indigo-100">About me</p>
                    <p className="hover:text-gray-500 text-base cursor-pointer leading-4 text-indigo-100">Skills & Experience</p>
                    <p className="hover:text-gray-500 text-base cursor-pointer leading-4 text-indigo-100">Portfolio</p>
                </div>
                <div id="contact"><h2 className="text-xl tracking-tight font-extrabold text-indigo-100 sm:text-3xl md:text-4xl mx-auto mt-10">Contact me here:</h2></div>
                <div className="flex items-center gap-x-8 mt-6">
                    <a href="https://github.com/simonxdev/" target="_blank" rel="noopener noreferrer">
                    <div className="cursor-pointer flex flex-row items-center">
                        <div className="cursor-pointer text-indigo-100 font-bold pr-2">Github: </div>
                        <img src="./assets/images/github.png" alt="SimonxDev on Github" width="20px" height="20px" />
                    </div>
                    </a>
                    <a href="https://twitter.com/SimonHH86" target="_blank" rel="noopener noreferrer">
                    <div className="cursor-pointer flex flex-row items-center">
                        <div className="cursor-pointer text-indigo-100 font-bold pr-2">Twitter: </div>
                        <svg className="fill-current text-orange-600 hover:text-orange-700 mt-2" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84"></path>
                        </svg>
                    </div></a>
                    <a href="mailto:simonlohmann@gmx.net" target="_blank" rel="noopener noreferrer">
                    <div className="cursor-pointer flex flex-row items-center">
                        <div className="cursor-pointer text-indigo-100 font-bold pr-2">Email: </div>
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 text-orange-600 hover:text-orange-700" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                        <path strokeLinecap="round" strokeLinejoin="round" d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207" />
                        </svg>
                    </div></a>
                </div>
                <div className="flex items-center mt-6">
                    <p className="text-base leading-4 text-indigo-100">
                        2022 <span className="font-semibold">Simon Lohmann</span>
                    </p>
                    <div className="border-l border-orange-600 pl-2 ml-2">
                        <p className="text-base leading-4 text-indigo-100">Inc. All rights reserved</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Footer;
